import { getLang } from "../../../js/utils/functions";

export const constants = {
  GET_FAQ_FEEDBACK: "GET_FAQ_FEEDBACK",
  GET_FAQ_FEEDBACK_SUCCESS: "GET_FAQ_FEEDBACK_SUCCESS",
  GET_FAQ_FEEDBACK_ERROR: "GET_FAQ_FEEDBACK_ERROR",
  SET_FAQ_FEEDBACK: "SET_FAQ_FEEDBACK",
  SET_FAQ_FEEDBACK_SUCCESS: "SET_FAQ_FEEDBACK_SUCCESS",
  SET_FAQ_FEEDBACK_ERROR: "SET_FAQ_FEEDBACK_ERROR",
};

const lang = getLang;
export const services = {
  getFaqFeedback: (id) => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: `{
        faqFeedback(faqId: ${id}){ id isGood }
      }`,
    },
  }),
  setFaqFeedback: (id, isGood) => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: `mutation { createFaqFeedback(faqId: ${id}, isGood: ${isGood}) {
          faqFeedback {
            id
            isGood
          }
          errors
        }
      }`,
    },
  }),
};
